import React, { useEffect, useState } from 'react';

const MODES = {
  light: {
    stroke: 'stroke-white',
    text: 'text-white',
    backgroundStroke: 'stroke-sky-200',
  },
  dark: {
    stroke: 'stroke-custom-light-blue',
    text: 'text-custom-light-blue',
    backgroundStroke: 'stroke-neutral-200',
  },
};

const calculateCircumference = (radius) => 2 * Math.PI * radius;

// TODO
// include light variant,
// include size variant
const AnimatedCircularProgress = ({
  percentage,
  radius = 45,
  containerSize = 'w-32 h-32',
  mode = 'dark',
  progressCircleStroke = '10',
  innerCirclePosition = 8,
  innerCircleStroke = '1',
  textSize = 'text-2xl',
}) => {
  const [progress, setProgress] = useState(0);
  const circumference = calculateCircumference(radius);
  const modeConfig = MODES[mode] || MODES[mode];

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prev) => {
        const nextValue = prev + 1;
        if (nextValue >= percentage) {
          clearInterval(interval);
          return percentage;
        }
        return nextValue;
      });
    }, 15);

    return () => {
      clearInterval(interval);
    };
  }, [percentage]);

  return (
    <div className={`relative flex items-center justify-center ${containerSize}`}>
      <svg className="absolute w-full h-full transform -rotate-90">
        {/** Decorative circle */}
        <circle
          cx="50%"
          cy="50%"
          r={radius - innerCirclePosition}
          className={`fill-none ${modeConfig.stroke}`}
          strokeWidth={innerCircleStroke}
        />
        {/** Outside circle */}
        <circle
          cx="50%"
          cy="50%"
          r={radius}
          strokeWidth={progressCircleStroke}
          className={`fill-none ${modeConfig.backgroundStroke}`}
        />
      </svg>
      {/** Animated Circle */}
      <svg className="absolute w-full h-full transform  -rotate-90">
        <circle
          cx="50%"
          cy="50%"
          r={radius}
          className={`fill-none ${modeConfig.stroke}`}
          strokeWidth={progressCircleStroke}
          strokeDasharray={circumference}
          strokeLinecap="round"
          strokeDashoffset={circumference - (circumference * progress) / 100}
          style={{ transition: 'stroke-dashoffset 0.1s linear' }}
        />
      </svg>
      <span className={`${textSize} font-black ${modeConfig.text}`}>{progress}%</span>
    </div>
  );
};

export default AnimatedCircularProgress;
